exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BuildingBlocks-module__wrapper___DxTgO{width:100%;display:grid;gap:3rem}.BuildingBlocks-module__wrapper___DxTgO strong{display:block;margin-bottom:1rem}.BuildingBlocks-module__wrapper___DxTgO .BuildingBlocks-module__grid___2f4rJ{display:grid;gap:1.5rem;width:100%;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));align-items:center;justify-items:start;justify-items:center}.BuildingBlocks-module__wrapper___DxTgO .BuildingBlocks-module__Groowy___3QcEg img{width:69%;margin:0 auto}.BuildingBlocks-module__wrapper___DxTgO .BuildingBlocks-module__Checkpunt___1tcvY img{width:85%;margin:0 auto}.BuildingBlocks-module__wrapper___DxTgO .BuildingBlocks-module__process-grid___3L0Dg{grid-template-columns:repeat(auto-fill,minmax(170px,1fr))}", ""]);

// exports
exports.locals = {
	"wrapper": "BuildingBlocks-module__wrapper___DxTgO",
	"grid": "BuildingBlocks-module__grid___2f4rJ",
	"Groowy": "BuildingBlocks-module__Groowy___3QcEg",
	"Checkpunt": "BuildingBlocks-module__Checkpunt___1tcvY",
	"process-grid": "BuildingBlocks-module__process-grid___3L0Dg"
};